export default __webpack_public_path__ + "static/media/505.9334fcfc.png";